import { signal } from '@preact/signals-react'

export const loadingSignal = signal(false)
